// Function to load scripts sequentially
function loadScript(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function(){};
  // Remove defer to ensure scripts execute after loading
  document.head.appendChild(script);
}

document.addEventListener("DOMContentLoaded", function() {
  // Load jQuery first
  loadScript('https://ajax.googleapis.com/ajax/libs/jquery/1.12.0/jquery.min.js', function() {
    // Then load Shopify script
    loadScript('https://cdn.shopify.com/assets/shopifyCh.js', function() {
      // Load swiper
      loadScript('https://cdn.shopify.com/assets/sh-swiper-bundle.min.js', function() {
        // Load form script
        loadScript('https://cdn.shopify.com/860029/form_361644.js?ver=...', function() {
          // Load joydia.net script
          loadScript('https://joydia.net/wpm/b73b305c4w82c1918fpb7086179m603a4010m.js');
        });
      });
    });
  });
});